class Config {
    static $inject = ['ngMetaProvider', '$httpProvider', "$compileProvider"];
    settings: any = window['settings'];

    constructor(ngMetaProvider, $httpProvider, $compileProvider) {

        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|whatsapp|messenger|tel):/);

        /**
         * MetaTags
         */

        $httpProvider.interceptors.push('InterceptorRequest');
    }
}

angular.module("app")
    .config(Config);
